module.exports = __webpack_public_path__ + "static/media/hack_3_bg.1daeabf1.jpg";